import { CognitoUserPool } from 'amazon-cognito-identity-js';

const REGION = process.env.REACT_APP_AWS_REGION;
const USER_POOL_ID = process.env.REACT_APP_AWS_ADMIN_POOL_ID;
const CLIENT_ID = process.env.REACT_APP_AWS_CLIENT_ID;
const poolData = { UserPoolId: USER_POOL_ID, ClientId: CLIENT_ID };

export const userPool = new CognitoUserPool(poolData);
export const USERPOOL_ID = 'cognito-idp.' + REGION + '.amazonaws.com/' + USER_POOL_ID;